import { render, staticRenderFns } from "./NovoUsuario.vue?vue&type=template&id=ad5ae502"
import script from "./NovoUsuario.vue?vue&type=script&lang=js"
export * from "./NovoUsuario.vue?vue&type=script&lang=js"
import style0 from "./NovoUsuario.vue?vue&type=style&index=0&id=ad5ae502&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports